<template>
    <div class="text-xs-center">
        <v-dialog v-model="value" persistent :max-width="maxWidth">
            <v-card>
                <v-card-title>
                    <span class="headline">{{title}}</span>
                </v-card-title>

                <v-card-text>
                    <slot></slot>
                </v-card-text> 

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="danger" @click="$emit('input', false)">{{cancel}}</v-btn>      
                </v-card-actions>        
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: "information-dialog", 
    props:{           
        maxWidth:{
            required: false, 
            default: "1000px",
            type: String          
        },
        title:{
            required: false, 
            type: String
        },
        value:{
            required: false,
            type: [Boolean]
        }
    },    
    computed:{
        cancel () {
            return this.$t("Common.cancel");
        }
    }
}
</script>